import { IngredientListContextProvider } from "./IngredientListContext";
import { useIngredientListContext } from "./useIngredientListContext";
import { GridPageHeader } from "src/components/Grid/PageGridHeader";
import { useTranslation } from "react-i18next";
import { IngredientPopover } from "./Popover/IngredientPopover";
import { EXTENSION_POINTS, ExtensionPoint } from "src/components/PuckExtensions";
import { useMemo } from "react";
import { IngredientsGrid } from "./IngredientsGrid";
import { EntityListLayout } from "src/components/Grid/EntityListLayout";
import { useIsProductUxV2 } from "src/hooks/useIsProductUxV2";

const IngredientsListComponent = () => {
    const { t } = useTranslation();
    const isProductUxV2 = useIsProductUxV2();
    const { globalSearch } = useIngredientListContext();
    const { search, setSearch } = globalSearch;
    const title = t("ingredients.list.title", "My ingredients");

    const IngredientGridMemo = useMemo(() => {
        return <IngredientsGrid />;
    }, []);

    return (
        <EntityListLayout
            appearance={isProductUxV2 ? "hub" : "legacy"}
            heading={<GridPageHeader title={title} />}
            ariaLabel={title}
            search={{
                value: search,
                onChange: setSearch,
                placeholder: t("rechercher_un_element"),
                showOnDesktop: false,
            }}
            actions={<IngredientPopover />}
            beforeGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.INGREDIENT_LISTING_HEADER} priority="high" />}
            afterGrid={<ExtensionPoint extensionPoint={EXTENSION_POINTS.INGREDIENT_LISTING_FOOTER} priority="high" />}
            hideHeadingOnMobile
        >
            {IngredientGridMemo}
        </EntityListLayout>
    );
};

const IngredientsList = () => {
    const isProductUxV2 = useIsProductUxV2();

    return (
        <IngredientListContextProvider appearance={isProductUxV2 ? "product-v2" : "legacy"}>
            <IngredientsListComponent />
        </IngredientListContextProvider>
    );
};
export default IngredientsList;
